import React from 'react';
import ContextMenu from 'devextreme-react/context-menu';



import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';


import './user-panel.scss';


function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
}

export default class UserPanel extends React.Component {
    render() {
        const { menuMode, menuItems } = this.props;
        return (
            <div className={'user-panel'}>

                {menuMode === 'context' && (
                    <ContextMenu
                        items={menuItems}
                        target={'.user-button'}
                        showEvent={'dxclick'}
                        width={170}
                        position={{ my: 'top center', at: 'bottom center' }}
                        cssClass={'user-menu'}
                    />
                )}
                {menuMode === 'list' && (
                    <List component="nav" >
                        {menuItems.map((item, index) =>
                            <ListItemLink key={index} href={item.path}>
                                <ListItemText primary={item.text} />
                            </ListItemLink>
                        )}
                    </List>
                )}
            </div>
        );
    }
}